import React from 'react';
import { CurrencyType } from '../types';
import { UPDATE_CURRENCY_FREQUENCY } from './constants';
import { updateExchangeRate } from './utils';
export const useUpdateCurrencyExchangeRate = () => {
  // TODO: Add more currencies here
  const currencies = [CurrencyType.THC, CurrencyType.THG, CurrencyType.GTHC, CurrencyType.GTHG, CurrencyType.BUSD, CurrencyType.BUSDT];

  const updateAllExchangeRates = () => currencies.forEach(updateExchangeRate);

  React.useEffect(() => {
    updateAllExchangeRates();
    const interval = setInterval(() => {
      updateAllExchangeRates();
    }, UPDATE_CURRENCY_FREQUENCY);
    return () => clearInterval(interval);
  }, []);
};